
export const parseJsonOrFallback = (input: string): any[] => {
    try {
        const parsed = JSON.parse(input);
        // Ensure the parsed result is an array
        if (Array.isArray(parsed)) {
            return parsed;
        }
        return [];
    } catch (error) {
        return [];
    }
};

export const parseOrFallback = <T>(input: string | undefined | null, fallback: T): T => {
    if (!input) {
        return fallback;
    }
    try {
        return JSON.parse(input) as T;
    } catch (error) {
        return fallback;
    }
};

